import './Button.css';

const Button = ({ children, className = "", onClick }) => {
    // 'legacy-btn' (was 'btn') — renamed to avoid colliding with the global
    // .btn system in src/styles/buttons.css
    const classNames = className?.length > 0 ?  `legacy-btn ${className}` : 'legacy-btn';

    // if onClick is not provided, throw an error
    if (!onClick || typeof onClick !== 'function') {
        throw new Error('Button component requires an onClick prop');
    }

    return (
        <button className={classNames} onClick={onClick}>
            {children}
        </button>
    );
}

export default Button;